exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".moneyCellWrapper-03766{display:flex;justify-content:flex-end}", ""]);

// Exports
exports.locals = {
	"moneyCellWrapper": "moneyCellWrapper-03766"
};